module.exports = __webpack_public_path__ + "img/20200512_162015.625fab4b.jpg";